var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import React, { useEffect, useId, useRef } from 'react';
import { useEnvironment } from '../../providers/env';
export var GROUP_TYPE;
(function (GROUP_TYPE) {
    GROUP_TYPE["REGION"] = "region";
    GROUP_TYPE["GROUP"] = "group";
    GROUP_TYPE["RAW"] = "raw";
})(GROUP_TYPE || (GROUP_TYPE = {}));
const GROUP_TYPE_ROLE_MAP = {
    [GROUP_TYPE.REGION]: 'region',
    [GROUP_TYPE.GROUP]: 'group',
    [GROUP_TYPE.RAW]: 'group',
};
const GroupContext = React.createContext({
    level: 0,
    labelId: '',
    labelTargetId: '',
    trackHeadingRendered: () => { },
});
export const useGroup = () => React.useContext(GroupContext);
export const Group = (_a) => {
    var { type: typeProp, children, sx } = _a, rest = __rest(_a, ["type", "children", "sx"]);
    const { level: parentLevel } = useGroup();
    const { flagInDevelopment } = useEnvironment();
    const type = typeProp || GROUP_TYPE.REGION;
    const uniqueId = useId();
    const labelId = `group-label-${uniqueId}`;
    const labelTargetId = `labeled-${uniqueId}`;
    const headingRenderTracker = useRef({
        hasHeadingRendered: false,
    });
    const trackHeadingRendered = () => {
        headingRenderTracker.current.hasHeadingRendered = true;
    };
    useEffect(() => {
        if (type === GROUP_TYPE.REGION) {
            setTimeout(() => {
                if (!headingRenderTracker.current.hasHeadingRendered) {
                    flagInDevelopment('Every <Group> component of type "region" must render a <Heading> component within it');
                }
            }, 500);
        }
    }, [flagInDevelopment, type]);
    const level = Math.min(parentLevel + (type === GROUP_TYPE.REGION ? 1 : 0), 5);
    const contextValue = {
        level,
        type,
        trackHeadingRendered,
        labelId,
        labelTargetId,
    };
    const Main = (_jsx(GroupContext.Provider, Object.assign({ value: contextValue }, { children: typeof children === 'function' ? children(contextValue) : children })));
    if (type === GROUP_TYPE.RAW) {
        return Main;
    }
    return (_jsx("div", Object.assign({ role: GROUP_TYPE_ROLE_MAP[type], "aria-labelledby": labelId, sx: Object.assign({ my: 2 }, sx) }, rest, { children: Main })));
};
